<template>
  <div class="topic-add">
    <div class="page-title">編輯題目</div>
    <div class="page-box">
      <!-- <el-tabs v-model="activeName">
        <el-tab-pane
          v-for="(item, index) in tabCard"
          :key="index"
          :label="item.label"
          :name="item.name"
        ></el-tab-pane> 
      </el-tabs> -->

      <components v-if="formLabelAlign" :is="activeName" :formLabelAlign="formLabelAlign" :ref="activeName"
      @preview="preview" @save="onSubmit" @cancel="cancel"></components>

    </div>
    <div class="mathematical-symbols" @mousedown.prevent="e => false">
      <span class="symbol" v-for="(item, idx) in mathSymbol" :key="idx" @mousedown="clickSymbol($event, item)">{{ item.value }}</span>
    </div>

    <DialogPreview v-if="previewSwitch" :form="form" @close="previewSwitch = false"></DialogPreview>

    <!-- 删除弹窗 -->
    <deleteDialog titleCh="確定捨棄輸入內容？"
      :centerDialogVisible="centerDialogVisible"
      @confirmFunction="$router.go(-1)" 
      @onCancelButton="centerDialogVisible = false;"
    ></deleteDialog>
  </div>
</template>

<script>
import gapFilling from "./components/gapFilling copy.vue";
// import gapFilling from "./components/gapFilling.vue";
import fillMatrix from "./components/fill_matrix.vue";
import multipleChoiceQuestion from "./components/multipleChoiceQuestion";
import sumProblem from "./components/sumProblem";
import sumProblemDivision from "./components/sumProblem_division";
import judgeQuestions from "./components/judgeQuestions";
import hotSpotMap from "./components/hotSpotMap";
import pictureDragDrop from "./components/pictureDragDrop";
import textDragDrop from "./components/textDragDrop";
import matching from "./components/matching";
import mathSymbol from './plugins/mathSymbol'
import { toSnakeCase } from '@/utils/data-format'
import DialogPreview from './dialog'
import deleteDialog from "@/components/deleteDialog";

import { getQuestionDetail, putQuestion } from "@/api/question";

export default {
  components: {
    gapFilling,
    fillMatrix,
    pictureDragDrop,
    textDragDrop,
    multipleChoiceQuestion,
    sumProblem,
    judgeQuestions,
    hotSpotMap,
    matching,
    sumProblemDivision,
    DialogPreview,
    deleteDialog
  },
  data() {
    return {
      mathSymbol,

      activeName: "gapFilling",
      tabCard: [
        { label: "選擇題", name: "multipleChoiceQuestion"},
        { label: "判斷題", name: "judgeQuestions"},
        { label: "填空題", name: "gapFilling"},
        { label: "算術題(+ - x)", name: "sumProblem"},
        { label: "熱點圖", name: "hotSpotMap"},
        { label: "文字拖拽題", name: "textDragDrop"},
        { label: "連線題", name: "matching"},
        { label: "圖片拖拽題", name: "pictureDragDrop"},
        { label: "算術題(÷)", name: "sumProblemDivision"},
        { label: "矩陣填空", name: "fillMatrix"},
      ],
      formLabelAlign: null,

      form: {},
      previewSwitch: false,
      centerDialogVisible: false
    };
  },
  methods: {
    // 取消
    cancel(obj) {
      let initData = JSON.stringify(this.formLabelAlign),
      curData = JSON.stringify(obj)

      if(initData != curData) {
        this.centerDialogVisible = true
      } else {
        this.$router.push('/question')
      }
    },
    // 预览
    preview(row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.previewSwitch = true
    },
    // 点击符号
    clickSymbol(event, item) {
      let selectionEnd = window.curFocus.selectionEnd,
      selectionStart = window.curFocus.selectionStart
      
      // 根据光标 将符号拼接回文本中 且将光标在符号后回显
      window.curFocus.value = window.curFocus.value.substr(0, selectionStart) + item.value + window.curFocus.value.substring(selectionEnd)
      window.curFocus.selectionStart = selectionStart + 1
      window.curFocus.selectionEnd = selectionStart + 1

      // 手动触发 input 事件
      window.curFocus.dispatchEvent(new Event('input'))

      // 阻止事件默认行为
      event.preventDefault();
      return false;
    },
    onSubmit(form, type) {
      let child = this.$refs[this.activeName]
      form.type = type

      // console.log(form)
      child.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          putQuestion(form.id, form).then(() => {
            this.$message.success('保存成功')
            this.$router.push({ name: 'question' })
          })
        }
      }).catch(err => {
        if (err.response.status === 401) {
          this.onSubmit(form, type)
        }
      })
    },  
    onBack() {},
  },
  created() {
    let id = this.$route.params.id
    getQuestionDetail(id).then((v) => {
      if(v.data.type == 8) this.activeName = 'sumProblem'
      else if(v.data.type == 9) this.activeName = 'textDragDrop'
      else if(v.data.type == 10) this.activeName = 'fillMatrix'
      else if(v.data.typeDisplay == 8) this.activeName = 'sumProblemDivision'
      else this.activeName = this.tabCard[v.data.type].name
      
      this.formLabelAlign = toSnakeCase(v.data);
    });
  }
};
</script>

<style lang="scss" scoped>
.page-box {
  padding: 20px;
  background-color: #fff;
  margin-top: 20px;

}
.mathematical-symbols {
  position: absolute;
  top: 350px;
  left: 50px;
  width: 270px;
  height: 100px;
  background-color: #fff;
  border-radius: 5px;
  padding: 10px 0 10px 10px;
  display: flex;
  overflow-y: auto;
  justify-content: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
  box-shadow: 1px 1px 2px 1px #ccc;
  box-sizing: border-box;
  z-index: 999;
  display: none;

  .symbol {
    width: 30px;
    height: 30px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;
    margin-right: 5px;

    &:hover {
      background-color: #eee;
    }
  }
}
</style>

<style lang="scss" >
.topic-add {
  font-family: 'GenSenRoundedTW-R';

  .required {
    color: #F56C6C;
  }

  .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before
  {
    content: none;
  }
  .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:after
  {
    content: '*';
    color: #F56C6C;
    margin-left: 4px;
  }


  .el-radio__input.is-checked + .el-radio__label {
       color: #3c3c3c !important;
   }
  .el-radio__input.is-checked .el-radio__inner {
    background: #fff !important;
    border-color: #3c3c3c !important;

    &:after {
      width: 7px !important;
      height: 7px !important;
      background-color: #3c3c3c !important;
    }
  }

  .sumType {
    .el-radio__label {
      font-size: 20px !important;
    }
  }

  .img-box {
    width: 100%;
    max-width: 410px;
    height: 300px;
    border: 1px solid rgba(112, 112, 112, 1);
    border-radius: 3px;
    padding: 20px;
    box-sizing: border-box;
    position: relative;
    margin-top: 10px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .close {
      position: absolute;
      top: 3px;
      right: 3px;
      width: 14px;
      height: 14px;
      cursor: pointer;

      &:before, &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 14px;
        height: 2px;
        background-color: #333;
        border-radius: 3px;
        transform: rotateZ(45deg);
      }
  
      &:after {
        transform: rotateZ(-45deg);
      }
    }

  }

  .single {
    height: fit-content;
    display: inline-block;
    margin-bottom: 5px;

    input[type="text"], .input {
      width: 100px;
      height: 40px;
      text-align: center;
      padding: 5px;
      box-sizing: border-box;
      font-size: 14px;
      font-weight: 700;
      border-radius: 10px;
      background-color: #fcd2ab;
      border: none;
      outline: none;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .over {
      width: 100px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #ffcca4;
      border-radius: 10px;
      .mixed {
        width: 40px;
        height: 40px;
        background-color: #ffcca4;
        padding: 0;
      }
      .mixed-empty {
        width: 1px;
        height: 40px;
        background-color: #ffcca4;
        padding: 0;
        cursor: default;
      }

      .fraction {
        height: 100%;
        width: 45px;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        position: relative;

        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          background-color: #333;
          width: 80%;
          height: 2px;
        }
        .numerator, .denominator {
          text-align: center;
          width: 100%;
          height: 45%;
          background-color: #ffcca4;
          border-radius: 3px;
          padding: 0;
        }
      }
    }
  }
}
</style>